export const priorityColors: any = {
  urgent: '#bb3354',
  high: '#f44336',
  medium: '#ff9800',
  low: '#2196f3',
  in_progress: '#808080',
  closed: '#808080',
  open: '#ffd180',
  specify: '#c4c4c4',
  add: '#3bc173',
  complete: '#3bc173',
  requested: '#7a7a7a',
  cancel: '#dd5040',
};

export const taskStatuses = {
  open: 'open',
  complete: 'complete',
  inProgress: 'in_progress',
  cancel: 'cancel',
  requested: 'requested',
} as const;

export const taskPriorities = {
  high: 'high',
  medium: 'medium',
  low: 'low',
} as const;

export const taskItemTypes = {
  docs: 'docs',
  info: 'info',
  documentESign: 'documentESign',
  catFiAddendum: 'catFiAddendum',
  newSignorAndGuarantorSignature: 'newSignorAndGuarantorSignature',
} as const;

export const assigneeKinds = {
  user: 'user',
  applicant: 'applicant',
  tradeReference: 'tradeReference',
  insuranceReference: 'insuranceReference',
} as const;

export const taskStatusMap = {
  open: 'Open',
  complete: 'Complete',
  in_progress: 'In Progress',
  requested: 'Requested',
  cancel: 'Cancel',
};

export const prioritySelectOptions = [
  { label: 'High', value: taskPriorities.high },
  { label: 'Medium', value: taskPriorities.medium },
  { label: 'Low', value: taskPriorities.low },
];

export const statusSelectOptions = [
  { label: 'Open', value: taskStatuses.open },
  { label: 'Complete', value: taskStatuses.complete },
  { label: 'In Progress', value: taskStatuses.inProgress },
  { label: 'Cancel', value: taskStatuses.cancel },
  { label: 'Requested', value: taskStatuses.requested },
];

export const priorityFiltersOptions = prioritySelectOptions;
export const statusFiltersOptions = statusSelectOptions;
